export interface IPaginationQueryParams {
  page?: number;
  pageSize?: number;
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}
